import styles from './Switch.module.css';
const Switch = (props) => {
    return (<div class={styles.switch} classList={{ [styles.checked]: props.checked }} onClick={() => props.onChange(!props.checked)}>
      <div class={styles.bar}/>
      <div class={styles.knob}/>
    </div>);
};
export default Switch;
